var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMaterial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 40,
    rx: 12,
    width: 40
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    height: "181.3%",
    width: "165%",
    x: "-32.5%",
    y: "-40.6%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0095d5",
    fillOpacity: 0.2,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillOpacity: 0.16,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#c)",
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.0001 0c2.5003 1.4546 5.001 2.9086 7.5006 4.3643-.002.9696 0 1.9389-.001 2.9086-1.6656-.9717-3.3333-1.9393-4.9993-2.91-.0006 1.9393-.0003 3.8789-.0003 5.8182-.833-.4856-1.6673-.969-2.5-1.4556 0-2.9083-.00029-5.8169 0-8.7255z",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 10.1851.0067.0047c.328.2162.6776.3984 1.0143.6011.4853.2783.9633.571 1.454.8391.849.4736 1.6829.9757 2.5259 1.461-.0016.9697 0 1.9393-.0006 2.909-1.666-.9713-3.3333-1.9396-5-2.9096-.0003-.9687.0004-1.937-.0003-2.9053z",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0081cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.501 4.3642c2.4996-1.4543 4.9999-2.908 7.4989-4.3633.0007 2.909.0003 5.8179 0 8.7272-1.633.9502-3.2663 1.9-4.8986 2.8508-.0413.0182-.077.0615-.1263.0511-.4907-.2682-.9687-.5609-1.454-.8391-.3367-.2027-.6863-.385-1.0143-.6011.3283-.2165.68-.3994 1.0173-.6028 1.3253-.7713 2.6509-1.5416 3.9759-2.3139.0004-.9693.001-1.9386-.0003-2.9079-1.6666.9689-3.3323 1.9396-4.9996 2.9076.001-.9697-.001-1.939.001-2.9086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5008 1.4542c.8343-.482 1.6656-.9693 2.499-1.4533.0003.9697.001 1.9393-.0004 2.9093-.8326.4846-1.6649.9706-2.4989 1.453-.0004-.9697-.001-1.9393.0003-2.909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 7.2735c.8334-.4846 1.6673-.969 2.5-1.455-.0003 1.94.001 3.88-.001 5.8196-2.5 1.4536-4.9986 2.9093-7.4989 4.3619.0007-.9696-.001-1.9393.0007-2.9089 1.6669-.969 3.3339-1.938 4.9992-2.9096 0-.9694 0-1.9387 0-2.908z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaterial);
export default __webpack_public_path__ + "static/media/ic_material.de87636aea8203a697a68d44fd53ee46.svg";
export { ForwardRef as ReactComponent };